import {Injectable} from "@angular/core";
import { getIconRegistry } from "@trumpf/ux.ui";


@Injectable({ providedIn: 'root' })
export class IconRegistry {
  public registerIconSet(namespace: string, iconPath: string, fileExtension: string): void {
    getIconRegistry().registerIconSet({
      ns: namespace,
      assetsPath: iconPath,
      fileExtension: fileExtension,
    });
  }

  public registerSingleIcon(name: string, iconPath: string, filledWeights: string[] | undefined, outlineWeights: string[] | undefined): void {
    getIconRegistry().setAssetsPath(iconPath);
    getIconRegistry().registerIcon({
      name: name,
      filledWeights: filledWeights,
      outlineWeights: outlineWeights,
    });
  }
}
